import { LazyWrapper } from "@/components/wrapper/lazy-wrapper";
import { lazyImport } from "@/utils/lazy-import-with-preload";
import { StepRouteItem } from "./routes.type";
import { StepRouter } from "./step-router";

// Lazy loaded components for better performance and code splitting
// export const ProfileCompanion = lazyImport(
//   () => import("@/pages/profiling/profiling-companion")
// );
// export const ProfilingStepPlanForYou = lazyImport(
//   () => import("@/pages/profiling/profiling-plan-for-you")
// );
export const MyFoodProfile = lazyImport(() => import("@/pages/profiling/my-food-profile"));
export const MyFoodProfilingCreating = lazyImport(
  () => import("@/pages/profiling/my-food-profiling-creating"),
);
export const ProfilingStepActivity = lazyImport(
  () => import("@/pages/profiling/profiling-activity"),
);
// export const ProfilingStepAllergies = lazyImport(
//   () => import("@/pages/profiling/profiling-allergies"),
// );
export const ProfilingComplete = lazyImport(() => import("@/pages/profiling/profiling-complete"));
export const GoToFoodProfile = lazyImport(
  () => import("@/features/go-to/pages/go-to-food-profile"),
);
export const GoToCandidatesCreating = lazyImport(
  () => import("@/features/go-to/pages/go-to-candidates-creating"),
);
export const GoToAddYourPlan = lazyImport(
  () => import("@/features/go-to/pages/go-to-add-your-plan"),
);
export const GoToProfilingCreating = lazyImport(
  () => import("@/features/go-to/pages/go-to-profiling-creating"),
);
export const GoToFeedback = lazyImport(() => import("@/features/go-to/pages/go-to-feedback"));
export const FavouriteFood = lazyImport(() => import("@/features/go-to/pages/favourite-food"));
export const FavouriteFoodProfile = lazyImport(
  () => import("@/features/go-to/pages/favourite-food-profile"),
);
export const FavouriteFoodCandidatesCreating = lazyImport(
  () => import("@/features/go-to/pages/favourite-candidates-creating"),
);
export const FavouriteFoodProfilePlan = lazyImport(
  () => import("@/features/go-to/pages/favourite-food-profile-plan"),
);
export const ProfilingCreating = lazyImport(() => import("@/pages/profiling/profiling-creating"));

export const ProfilingStepDietary = lazyImport(() => import("@/pages/profiling/profiling-dietary"));
export const OnboardingFoodAvoids = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-food-avoids"),
);
export const OnboardingSupermarket = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-supermarket"),
);
export const OnboardingFavouriteBrands = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-favourite-brands"),
);
export const OnboardingActivityLevel = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-activity-level"),
);
export const OnboardingAddFood = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-add-food"),
);
export const OnboardingPersonalFoods = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-personal-foods"),
);
export const OnboardingBuildingScreen = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-building-screen"),
);
export const OnboardingPlanBuilt = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-plan-built"),
);
export const ProfilingGoalPage = lazyImport(() => import("@/pages/profiling/profiling-goal"));
export const ProfilingKnowYou = lazyImport(() => import("@/pages/profiling/profiling-know-you"));
export const ProfilingSupermarket = lazyImport(
  () => import("@/features/lifestyle/pages/onboarding-supermarket"),
);
export const ProfilingBreakfast = lazyImport(
  () => import("@/features/lifestyle/pages/onboarding-breakfast"),
);
export const ProfilingDinner = lazyImport(
  () => import("@/features/lifestyle/pages/onboarding-dinner"),
);
export const ProfilingLunch = lazyImport(
  () => import("@/features/lifestyle/pages/onboarding-lunch"),
);
export const ProfilingSnack = lazyImport(
  () => import("@/features/lifestyle/pages/onboarding-snack"),
);
export const ProfilingLifestyle = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-lifestyle"),
);
export const ProfilingDietaryPreferences = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-dietary-preferences"),
);
export const OnboardingGoToFoodProfile = lazyImport(
  () => import("@/features/go-to/pages/onboarding-go-to-food-profile"),
);
export const OnboardingGoToCandidatesCreating = lazyImport(
  () => import("@/features/go-to/pages/onboarding-go-to-candidates-creating"),
);
export const OnboardingGoToAddPlan = lazyImport(
  () => import("@/features/go-to/pages/onboarding-go-to-add-plan"),
);
export const OnboardingCreatingSuggestions = lazyImport(
  () => import("@/features/go-to/pages/onboarding-creating-suggestions"),
);
// export const ProfilingRecommendedCalories = lazyImport(
//   () => import("@/pages/profiling/profiling-recommended-calories")
// );
export const ProfilingToldWhatToEat = lazyImport(
  () => import("@/pages/profiling/profiling-told-what-to-eat"),
);
export const ProfilingStepUserDetails = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-user-details"),
);
export const OnboardingName = lazyImport(() => import("@/features/onboarding/pages/name"));
export const OnboardingGoal = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-goal"),
);
export const OnboardingGender = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-gender"),
);
// Dropped in onboarding v5 — the eating-disorder question moved to /diagnostic
// (src/features/onboarding/pages/diagnostic); file preserved on disk.
// export const OnboardingDisorders = lazyImport(
//   () => import("@/features/user-profile/pages/onboarding-disorders"),
// );
export const OnboardingBirthday = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-birthday"),
);
export const OnboardingHeight = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-height"),
);
export const OnboardingWeight = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-weight"),
);
export const OnboardingActivity = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-activity"),
);
export const OnboardingSummary = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-summary"),
);
export const OnboardingPersonaliseIntro = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-personalise-intro"),
);
export const OnboardingDietary = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-dietary"),
);
// export const OnboardingMilk = lazyImport(
//   () => import("@/features/user-profile/pages/onboarding-milk"),
// );
export const OnboardingAllergies = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-allergies"),
);
export const OnboardingFoodAvoidsV2 = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-food-avoids-v2"),
);
// export const OnboardingSupermarketV2 = lazyImport(
//   () => import("@/features/user-profile/pages/onboarding-supermarket-v2"),
// );
export const OnboardingMeetNutriCoach = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-meet-nutricoach"),
);
// The onboarding-survey screens (nutricoach-reason, tracking-experience, tracking-why,
// self-perception, breakfast/lunch/dinner habits, dinner-companions) were deleted with
// PUT /api/v1/onboarding/survey — see git history.

export const ProfilingStepUserStatus = lazyImport(
  () => import("@/features/user-profile/pages/onboarding-user-status"),
);
export const ProfilingWelcomePage = lazyImport(() => import("@/pages/profiling/profiling-welcome"));

// ─── Onboarding v5 (dark theme) pages — src/features/onboarding/pages ───
export const OnboardingV5Goal = lazyImport(() => import("@/features/onboarding/pages/goal"));
export const OnboardingV5HelpWith = lazyImport(
  () => import("@/features/onboarding/pages/help-with"),
);
export const OnboardingV5ProgressChange = lazyImport(
  () => import("@/features/onboarding/pages/progress-change"),
);
export const OnboardingV5StartingFrom = lazyImport(
  () => import("@/features/onboarding/pages/starting-from"),
);
export const OnboardingV5GettingTo = lazyImport(
  () => import("@/features/onboarding/pages/getting-to"),
);
export const OnboardingV5Height = lazyImport(() => import("@/features/onboarding/pages/height"));
export const OnboardingV5Birthday = lazyImport(
  () => import("@/features/onboarding/pages/birthday"),
);
export const OnboardingV5FatLoss = lazyImport(() => import("@/features/onboarding/pages/fat-loss"));
export const OnboardingV5Sex = lazyImport(() => import("@/features/onboarding/pages/sex"));
export const OnboardingV5Activity = lazyImport(
  () => import("@/features/onboarding/pages/activity"),
);
export const OnboardingV5Workouts = lazyImport(
  () => import("@/features/onboarding/pages/workouts"),
);
export const OnboardingV5Move = lazyImport(() => import("@/features/onboarding/pages/move"));
export const OnboardingV5Building = lazyImport(
  () => import("@/features/onboarding/pages/building"),
);
export const OnboardingV5BuildingConfirmation = lazyImport(
  () => import("@/features/onboarding/pages/building-confirmation"),
);
export const OnboardingV5AppPreview = lazyImport(
  () => import("@/features/onboarding/pages/app-preview"),
);
export const OnboardingV5MeetNutriCoach = lazyImport(
  () => import("@/features/onboarding/pages/meet-nutricoach"),
);

const onboardingStepRouter = new StepRouter();

onboardingStepRouter.addRoute({
  path: "/profiling/step-name",
  children: (
    <LazyWrapper>
      <OnboardingName />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingName,
  showPrevious: false,
});

// ─── Onboarding v5 flow (Figma "NutriCoach Onboarding v1.1 - v5") ───
// The pre-v5 steps (goal/gender/birthday/height/weight/activity/summary,
// survey steps, dietary/allergies/food-avoids, meet-nutricoach) were replaced
// in this block; their pages are preserved on disk under
// src/features/user-profile/pages — see git history for the old route defs.

onboardingStepRouter.addRoute({
  path: "/profiling/step-goal",
  children: (
    <LazyWrapper>
      <OnboardingV5Goal />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Goal,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-help-with",
  children: (
    <LazyWrapper>
      <OnboardingV5HelpWith />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5HelpWith,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-progress-change",
  children: (
    <LazyWrapper>
      <OnboardingV5ProgressChange />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5ProgressChange,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-starting-from",
  children: (
    <LazyWrapper>
      <OnboardingV5StartingFrom />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5StartingFrom,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-getting-to",
  children: (
    <LazyWrapper>
      <OnboardingV5GettingTo />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5GettingTo,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-fat-loss",
  children: (
    <LazyWrapper>
      <OnboardingV5FatLoss />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5FatLoss,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-height",
  children: (
    <LazyWrapper>
      <OnboardingV5Height />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Height,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-birthday",
  children: (
    <LazyWrapper>
      <OnboardingV5Birthday />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Birthday,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-gender",
  children: (
    <LazyWrapper>
      <OnboardingV5Sex />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Sex,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-activity",
  children: (
    <LazyWrapper>
      <OnboardingV5Activity />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Activity,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-workouts",
  children: (
    <LazyWrapper>
      <OnboardingV5Workouts />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Workouts,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-move",
  children: (
    <LazyWrapper>
      <OnboardingV5Move />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Move,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-building",
  children: (
    <LazyWrapper>
      <OnboardingV5Building />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5Building,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-building-confirmation",
  children: (
    <LazyWrapper>
      <OnboardingV5BuildingConfirmation />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5BuildingConfirmation,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-app-preview",
  showStep: false,
  showPrevious: false,
  children: (
    <LazyWrapper>
      <OnboardingV5AppPreview />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5AppPreview,
});

onboardingStepRouter.addRoute({
  path: "/profiling/step-meet-nutricoach",
  showStep: false,
  showPrevious: false,
  children: (
    <LazyWrapper>
      <OnboardingV5MeetNutriCoach />
    </LazyWrapper>
  ),
  lazyRoute: OnboardingV5MeetNutriCoach,
});

// ─── Legacy onboarding routes (dropped Phase 5; files preserved on disk) ───
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-user-status",
//   children: <LazyWrapper><ProfilingStepUserStatus /></LazyWrapper>,
//   lazyRoute: ProfilingStepUserStatus,
// });
//
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-lifestyle",
//   children: <LazyWrapper><ProfilingLifestyle /></LazyWrapper>,
//   lazyRoute: ProfilingLifestyle,
// });
//
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-dietary-preferences",
//   children: <LazyWrapper><ProfilingDietaryPreferences /></LazyWrapper>,
//   lazyRoute: ProfilingDietaryPreferences,
// });
//
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-food-avoids",
//   children: <LazyWrapper><OnboardingFoodAvoids /></LazyWrapper>,
//   lazyRoute: OnboardingFoodAvoids,
// });
//
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-supermarket",
//   children: <LazyWrapper><OnboardingSupermarket /></LazyWrapper>,
//   lazyRoute: OnboardingSupermarket,
// });
//
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-favourite-brands",
//   showStep: false,
//   children: <LazyWrapper><OnboardingFavouriteBrands /></LazyWrapper>,
//   lazyRoute: OnboardingFavouriteBrands,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-activity-level",
//   children: (
//     <LazyWrapper>
//       <OnboardingActivityLevel />
//     </LazyWrapper>
//   ),
//   lazyRoute: OnboardingActivityLevel,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-add-food",
//   showStep: false,
//   children: (
//     <LazyWrapper>
//       <OnboardingAddFood />
//     </LazyWrapper>
//   ),
//   lazyRoute: OnboardingAddFood,
// });

// ─── Legacy final onboarding screen (dropped Phase 5; file preserved) ───
// onboardingStepRouter.addRoute({
//   path: "/profiling/step-personal-foods",
//   children: <LazyWrapper><OnboardingPersonalFoods /></LazyWrapper>,
//   showPrevious: false,
//   showStep: false,
//   lazyRoute: OnboardingPersonalFoods,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-plan-built",
//   children: (
//     <LazyWrapper>
//       <OnboardingPlanBuilt />
//     </LazyWrapper>
//   ),
//   showPrevious: false,
//   showStep: false,
//   lazyRoute: OnboardingPlanBuilt,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-goal",
//   children: (
//     <LazyWrapper>
//       <ProfilingGoalPage />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-activity",
//   children: (
//     <LazyWrapper>
//       <ProfilingStepActivity />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-know-you",
//   children: (
//     <LazyWrapper>
//       <ProfilingKnowYou />
//     </LazyWrapper>
//   ),
//   showStep: false,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-breakfast",
//   children: (
//     <LazyWrapper>
//       <ProfilingBreakfast />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-lunch",
//   children: (
//     <LazyWrapper>
//       <ProfilingLunch />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-dinner",
//   children: (
//     <LazyWrapper>
//       <ProfilingDinner />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-snack",
//   children: (
//     <LazyWrapper>
//       <ProfilingSnack />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-told-what-to-eat",
//   children: (
//     <LazyWrapper>
//       <ProfilingToldWhatToEat />
//     </LazyWrapper>
//   ),
//   showStep: false,
//   showPrevious: false,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-dietary",
//   children: (
//     <LazyWrapper>
//       <ProfilingStepDietary />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-food-preferences",
//   children: (
//     <LazyWrapper>
//       <OnboardingFoodAvoids />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-calories",
//   children: (
//     <LazyWrapper>
//       <ProfilingRecommendedCalories />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-go-to-food-profile",
//   children: (
//     <LazyWrapper>
//       <OnboardingGoToFoodProfile />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-go-to-candidates-creating",
//   children: (
//     <LazyWrapper>
//       <OnboardingGoToCandidatesCreating />
//     </LazyWrapper>
//   ),
//   showPrevious: false,
//   showStep: false,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-go-to-add-plan",
//   children: (
//     <LazyWrapper>
//       <OnboardingGoToAddPlan />
//     </LazyWrapper>
//   ),
//   previousPath: "/profiling/step-go-to-food-profile",
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-go-to-creating",
//   children: (
//     <LazyWrapper>
//       <OnboardingCreatingSuggestions />
//     </LazyWrapper>
//   ),
//   showPrevious: false,
//   showStep: false,
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-creating",
//   children: (
//     <LazyWrapper>
//       <ProfilingCreating />
//     </LazyWrapper>
//   ),
// });

// onboardingStepRouter.addRoute({
//   path: "/profiling/step-welcome",
//   children: (
//     <LazyWrapper>
//       <ProfilingWelcomePage />
//     </LazyWrapper>
//   ),
//   showPrevious: false,
//   showStep: false,
// });

export const onboardingRoutes: readonly StepRouteItem[] = onboardingStepRouter.getRoutes();

// export const profilingGoToProfileRoute: readonly StepRouteItem[] = [
//   // My Food Profile
//   {
//     path: "/profiling/food",
//     children: (
//       <LazyWrapper>
//         <MyFoodProfile />
//       </LazyWrapper>
//     ),

//     isProtected: true,
//   },

//   {
//     path: "/profiling/creating",
//     children: (
//       <LazyWrapper>
//         <MyFoodProfilingCreating />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/complete",
//     children: (
//       <LazyWrapper>
//         <ProfilingComplete />
//       </LazyWrapper>
//     ),

//     isProtected: true,
//   },
//   // My Favourites
//   {
//     path: "/profiling/go-to",
//     children: (
//       <LazyWrapper>
//         <GoToFoodProfile />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/go-to/candidates-creating",
//     children: (
//       <LazyWrapper>
//         <GoToCandidatesCreating />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/go-to/add-plan",
//     children: (
//       <LazyWrapper>
//         <GoToAddYourPlan />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/go-to/profiling-creating",
//     children: (
//       <LazyWrapper>
//         <GoToProfilingCreating />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/go-to/feedback",
//     children: (
//       <LazyWrapper>
//         <GoToFeedback />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/favourites",
//     children: (
//       <LazyWrapper>
//         <FavouriteFood />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/favourites/:mealTime",
//     children: (
//       <LazyWrapper>
//         <FavouriteFoodProfile />
//       </LazyWrapper>
//     ),
//     isProtected: true,
//   },
//   {
//     path: "/profiling/favourites/candidates-creating/:mealTime",
//     children: (
//       <LazyWrapper>
//         <FavouriteFoodCandidatesCreating />
//       </LazyWrapper>
//     ),

//     isProtected: true,
//   },

//   {
//     path: "/profiling/favourites/add-plan/:mealTime",
//     children: (
//       <LazyWrapper>
//         <FavouriteFoodProfilePlan />
//       </LazyWrapper>
//     ),

//     isProtected: true,
//   },
// ];
